export default "__VITE_ASSET__Ovg7xq27__"